export enum ApiConstant {
    apiVersion = "v1",
    apiEndpoint = `_forms/${ApiConstant.apiVersion}/forms`
}
